<template>
  <div
    v-if="infoList"
    class="main">
    <module-title :module-title="moduleTitle"/>
    <div class="info-list">
      <div v-for="(item, index) in list" :key="index">
        <a v-if="index < 2" :href="item.infoUrl" style="display:inline-block; width: 100%">
        <div v-if="index < 2" class="info-list-item" :class="{ 'nopadding': index === 0, 'noborderb': index === 1 }">
          <div class="item-left">
            <div class="title">{{ item.subject }}</div>
            <div class="time">{{ item.createDate }}</div>
            <div class="see">
              <!-- <img src="https://cdn.51ljb.cn/ljb_icons_zx_dz.png">
              <span>{{ item.likes }}</span> -->
              <img src="https://cdn.51ljb.cn/ljb_icons_zx_ll.png">
              <span>{{ item.readsCount }}</span>
            </div>
          </div>
          <div class="item-right">
            <img :src="item.hCoverFileUrl || item.vCoverFileUrl">
          </div>
        </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitleNew'
import {mapGetters} from 'vuex'
let namespce = 'Channel'
export default {
  name: 'ListService',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '热门资讯',
        text: '查看更多',
        url: 'Information',
      },
      list: []
    }
  },
  filters: {
    formatTime: (time) => {
      let dateDiff = new Date().getTime() - new Date(time).getTime()
      let hours=Math.floor(dateDiff/(3600*1000))
      let minutes=Math.floor(hours*60)
      if (hours < 1) {
        if(!minutes) return '刚刚发布'
        return minutes + '分钟前发布'
      }
      if (hours >= 1 && hours < 24) {
        return hours + '小时前发布'
      }
      if (hours >= 24) {
        return Math.floor(hours/24) + '天前发布'
      }
    },
  },
  computed: {
    ...mapGetters(namespce, ['getChannelData']),
    ...mapGetters('User', [
      'getUserInfo',
    ]),
    infoList () {
      if (this.getChannelData) {
        if (this.getChannelData.activity && Object.keys(this.getChannelData.activity).length > 0) {
          return this.getChannelData.activity
        }
      }
      return null
    },
    getRightsUrl () {
      return 'https://app.51ljb.cn/app-h5/agreement/a.html'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    goDoc: function (item) {
      this.$utils.checkCanGoRouter(item.url)
    },
    getData() {
      this.$get.contentList({
        page: '1',
        searchContent: '',
        tagIds: '',
        limit: '10'
      }).then(res => {
        const rows = res.data.list
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].infoUrl.indexOf('51ljb') !== -1 && this.getUserInfo) {
            rows[i].infoUrl = rows[i].infoUrl+'&token='+this.getUserInfo.token
          }
        }
        this.list = res.data.list
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .main{
    // margin-top: $margin;
    background: #fff;
    padding-bottom: $padding;
  }
  .info-list{
    padding:0 $padding 0 $padding;
    box-sizing:  border-box;
    .info-list-item{
      width: 100%;
      height: 85px;
      display: flex;
      border-bottom: 1px solid #F0F0F0;
      padding-top: $padding;
      .item-left{
        flex: 2;
        padding-right: $padding;
        width: calc(100% - 125px);
        position: relative;
        .title{
          width: 100%;
          // overflow: hidden;
          // text-overflow:ellipsis;
          // white-space: nowrap;
          overflow:hidden;  //超出文本隐藏
          text-overflow:ellipsis;  ///超出部分省略号显示
          display:-webkit-box;  //弹性盒模型
          -webkit-box-orient:vertical;  //上下垂直
          -webkit-line-clamp:2;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
        }
      }
      .item-right{
        flex: 1;
        width: 110px;
        height: 70px;
        >img{
          width: 100%;
          height: 100%;
          border-radius: 2px;
        }
      }
      .time{
        font-size: 10px;
        font-weight: 400;
        color: #999999;
        // margin-top: 3px;
        position: absolute;
        top: 42px;
      }
      .see{
        font-size: 10px;
        font-weight: 400;
        color: #999999;
        // margin-top: 1px;
        position: absolute;
        top: 59px;
        >img{
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-top: -5px;
        }
        >img:nth-child(3){
          margin-left: 10px;
        }
      }
    }
    .nopadding{
      padding-top: 0;
    }
    .noborderb{
      border-bottom: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/list/ListInformation.vue